// extracted by css-extract-rspack-plugin
export default {"token":"qR7KcUDKdrElilri"};